import { regexEscape } from '@magnetic/lib';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const filterOptions = /* @__PURE__ */ __name((autocomplete, value, maxShownOptions) => {
  const filteredOptions = [];
  const reg = new RegExp(`(${regexEscape(value)})`, "i");
  for (const option of autocomplete) {
    if (reg.test(option)) {
      filteredOptions.push(option);
    }
  }
  return filteredOptions.slice(0, maxShownOptions);
}, "filterOptions");

export { filterOptions };
//# sourceMappingURL=filter-options.js.map
